import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from '@dixa/lib-shared-habla';
import { AppLink } from 'components/appLink';
import { getUserDisplayName } from 'utils/user/getUserDisplayName';
import styles from './conversationHeaderPastAssignee.module.scss';
export const ConversationHeaderPastAssignee = ({ agent, }) => {
    return (_jsx(AppLink, Object.assign({ path: "/contacts/user/:id", params: {
            path: { id: agent.id },
        } }, { children: _jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx(Avatar, { user: agent }), _jsx("div", { children: _jsx("div", Object.assign({ className: styles.name }, { children: getUserDisplayName(agent) })) })] })) })));
};
